module.exports = __webpack_public_path__ + "static/slide-3-687bef21f471bab0832d5127ac6f5bc9.svg";